import { PageHeader } from "../components/PageHeader";
import { ConcernGuide } from "../components/ConcernGuide";
import { CTABanner } from "../components/CTABanner";
import { SEO } from "../components/SEO";

export default function Start() {
  return (
    <div data-testid="start-page">
      <SEO
        title="Not Sure Where to Start? | Thrive Pediatric Therapy, Nassau"
        description="Tell us what you're noticing about your child and we'll gently point you toward physiotherapy, occupational therapy, speech & language or feeding therapy in Nassau, Bahamas."
      />
      <PageHeader
        testId="start-header"
        eyebrow="We're here to help"
        title="Embodying what it means to thrive"
        description="You know your child best. Share what you're noticing and we'll help you find the right first step, no pressure, no jargon."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <ConcernGuide />
      </section>
      <CTABanner title="Still weighing it up?" subtitle="An initial evaluation is a relaxed first visit - come in, ask everything, and decide from there." />
    </div>
  );
}
